import React from 'react';
import { useTranslation } from 'react-i18next';
import ContactConsultationForm from './ContactConsultationForm';
import ContactHero from './ContactHero';
import ContactInfoCards from './ContactInfoCards';
import SEO from '../SEO/SEO';
import { BreadcrumbSchema } from '../SEO/StructuredData';

const ContactPageLayout: React.FC = () => {
  const { t } = useTranslation();

  return (
    <main className="pt-[72px]">
      <SEO
        title={t('contactSection.seo.title')}
        description={t('contactSection.seo.description')}
        keywords={t('contactSection.seo.keywords')}
      />
      <BreadcrumbSchema items={[{ name: t('contactSection.breadcrumb'), url: '/contact' }]} />
      <ContactHero />
      <section className="py-24 bg-[#F7F8FA]">
        <div className="max-w-6xl mx-auto px-6">
          <div className='grid grid-cols-1 lg:grid-cols-5 gap-8'>
            <div className='lg:col-span-3'>
          <ContactConsultationForm />
          </div>
          <div className='lg:col-span-2'>
          <ContactInfoCards />
          </div>
        </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPageLayout;
